import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../lib/firebase";
import { useMe } from "../lib/useMe";

export default function Layout() {
  const navigate = useNavigate();
  const { me } = useMe();
  const isAdmin = me?.is_admin ?? false;
  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium ${
      isActive ? "text-lapis-500 border-b-2 border-lapis-500" : "text-ink-700 hover:text-ink-800"
    }`;

  const mobileNavClass = ({ isActive }: { isActive: boolean }) =>
    `py-3.5 text-xs ${isActive ? "text-lapis-500 font-medium" : "text-ink-700"}`;

  return (
    <div className="min-h-screen flex flex-col relative z-10">
      <header className="border-b border-papyrus-200 bg-papyrus-100/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="py-4 flex items-center gap-2">
            <span className="font-display text-2xl tracking-tight">Thot</span>
            <span className="text-xs font-mono text-scribe-600 uppercase tracking-wider">AI</span>
          </Link>
          <nav className="hidden md:flex items-center">
            <NavLink to="/" end className={navClass}>
              Accueil
            </NavLink>
            <NavLink to="/review" className={navClass}>
              Révision
            </NavLink>
            <NavLink to="/certs" className={navClass}>
              Certifications
            </NavLink>
            <NavLink to="/dashboard" className={navClass}>
              Tableau de bord
            </NavLink>
            {isAdmin && (
              <NavLink to="/authoring" className={navClass}>
                Atelier
              </NavLink>
            )}
          </nav>
          <button onClick={handleSignOut} className="text-sm text-ink-700 hover:text-ink-800">
            Se déconnecter
          </button>
        </div>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-8 pb-24 md:pb-8">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav
        className="md:hidden fixed bottom-0 inset-x-0 bg-papyrus-100 border-t border-papyrus-200 z-20"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className={`grid text-center ${isAdmin ? "grid-cols-5" : "grid-cols-4"}`}>
          <NavLink to="/" end className={mobileNavClass}>
            Accueil
          </NavLink>
          <NavLink to="/review" className={mobileNavClass}>
            Révision
          </NavLink>
          <NavLink to="/certs" className={mobileNavClass}>
            Certifs
          </NavLink>
          <NavLink to="/dashboard" className={mobileNavClass}>
            Stats
          </NavLink>
          {isAdmin && (
            <NavLink to="/authoring" className={mobileNavClass}>
              Atelier
            </NavLink>
          )}
        </div>
      </nav>
    </div>
  );
}
